import {
    GetGoalList,
    DeleteGoal,
    CreateGoal,
    GetGoal,
    UpdateGoal,
} from '@src/services/goal'

export const state = {
    goalList: [],
}

export const getters = {
    totalList(state) {
        return state.goalList.data ? state.goalList.data.totalItemCount : 0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.goalList = newList
    },
    NEXT_PAGE_LIST(state, newList) {
        newList.forEach((goal) => {
            state.goalList.data.items.push(goal)
        })
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const resp = await GetGoalList(parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async deleteGoal({ dispatch }, goalPublicId) {
        const resp = await DeleteGoal(goalPublicId)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async createGoal({ _ }, goalForm) {
        const resp = await CreateGoal(goalForm)
        return resp
    },
    async setGoalForm({ _ }, goalPublicId) {
        const resp = await GetGoal(goalPublicId)
        return resp
    },
    async updateGoal({ _ }, goal) {
        const resp = await UpdateGoal(goal)
        return resp
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetGoalList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
}